module.exports = __webpack_public_path__ + "static/media/lastfm.372681f9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/lastfm.svg
// module id = 3111
// module chunks = 7